export default "__VITE_ASSET__CGHTsq4Q__"